/**
 * SA-1418 (B4): the escalated badge's words. The badge carries no native
 * `title` (two tooltips would show): on the collapsed rail the words ride the
 * row's tip, on the expanded rail the badge has its own tip, and the link's
 * accessible description says them in both.
 */
export const ESCALATED_TIP = 'Escalated to a human'

export function escalatedWords(n: number): string {
  return `${n} escalated to a human`
}
